import { Link } from "react-router-dom";
import { Camera, MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

const btn = "flex flex-col items-center justify-center gap-0.5 rounded-xl py-2 text-[12.5px] font-bold transition-transform active:scale-95";

export const MobileBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 gap-2 border-t border-slate-200 bg-white px-3 pb-[calc(0.5rem+env(safe-area-inset-bottom))] pt-2 shadow-[0_-8px_30px_-12px_rgba(0,0,0,0.25)] lg:hidden"
    data-testid="mobile-bottom-bar"
  >
    <a href={SITE.phoneHref} className={`${btn} bg-brand-blue text-white`} data-testid="mobile-bar-call">
      <Phone className="h-5 w-5" /> Anrufen
    </a>
    <a href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" className={`${btn} bg-brand-whatsapp text-brand-anthracite`} data-testid="mobile-bar-whatsapp">
      <MessageCircle className="h-5 w-5" /> WhatsApp
    </a>
    <Link to="/schaden-melden" className={`${btn} bg-brand-yellow text-brand-anthracite`} data-testid="mobile-bar-damage">
      <Camera className="h-5 w-5" /> Schaden melden
    </Link>
  </div>
);
